import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../../signalr/helpers'
import type { StreamDefinition } from '../../../signalr/types'
import { updateUserDashboard } from './actions'
import type { UserDashboardEntry } from './types'

export const subscribeToUserDashboardDefinition: StreamDefinition<
  [],
  UserDashboardEntry[],
  Action
> = {
  method: 'GetUserDashboard',
  strategy: 'merge',
  getParams,
  mapResponse: updateUserDashboard,
  cancelOn: ['userDashboard.unsubscribe']
}
